import Component from '../core/Component'
import Snippet from '../core/Snippet'

export default class ProductList extends Component {

    prepare() {
        this.snippet = new Snippet(this.element)
        this.snippet.afterUpdate = this.handleAfterUpdate
    }

    handleAfterUpdate = ({ append: appendId }) => {
        if (appendId === this.element.id) {
            impressions = previousImpressions.concat(impressions)
        }

        if (impressions.length) {
            dataLayer.push({
                'ecommerce': {
                    'impressions ': undefined
                }
            })
            dataLayer.push({
                'ecommerce': {
                    'impressions ': impressions
                }
            })
            previousImpressions = [...impressions]
            impressions = []
        }
    }

}